import { render, staticRenderFns } from "./2000_Reporting_Sus_Emails.vue?vue&type=template&id=2c9a9518&scoped=true&lang=pug"
var script = {}
import style0 from "./2000_Reporting_Sus_Emails.vue?vue&type=style&index=0&id=2c9a9518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9a9518",
  null
  
)

export default component.exports